import React from 'react'
const AppContext = React.createContext('AppContext');
const UserContext = React.createContext('UserContext');
const DialogContext = React.createContext('DialogContext');

export {AppContext, UserContext, DialogContext}